var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":"3","pageType":"service","currentIndex":_vm.currentIndex}}),_c('ServerPage',{on:{"section-change":_vm.handleSectionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }